import { Platform } from './platform';

// Platform-agnostic storage interface
export interface Storage {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  removeItem: (key: string) => Promise<void>;
}

// Web storage implementation
class WebStorage implements Storage {
  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key);
  }

  async setItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  }

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key);
  }
}

// No-op storage implementation for SSR
class NoopStorage implements Storage {
  async getItem(): Promise<string | null> {
    return null;
  }

  async setItem(): Promise<void> {}

  async removeItem(): Promise<void> {}
}

// Create storage based on platform
export const storage = Platform.select({
  web: new WebStorage(),
  native: new NoopStorage() // This will be overridden in the mobile app
}); 